import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import InsightsPage from './pages/InsightsPage';
import PodcastsPage from './pages/PodcastsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import WhatsAppFloatingButton from './pages/WhatsAppFloatingButton';

import TermsConditionPage from './pages/TermsConditionPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/podcasts" element={<PodcastsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
             <Route path="/WhatsAppFloatingButton" element={<WhatsAppFloatingButton />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicyPage /> } />
            <Route path="/Terms&Condition" element={<TermsConditionPage /> } />
           
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
